









































































































import {Component, PropSync, Watch} from 'vue-property-decorator'
import BaseFilter from '@/components/Filter/BaseFilter';
import {Getter, Action} from 'vuex-class';
import {SelectWings,
  ToggleWings,
  TimeoutWings,
  NewPriceWings,
  NumberWings
} from 'wings-ui-components';
import {QuantityLimitFilter, QuantityLimitFilterImpl} from '@/store/settings/quantity_limits/types';

import {notifyError} from '@/utils/notify-helper';
import {MessageTypeItem} from "@/store/settings/message_types/types";
import {TransportItem} from "@/store/transport/types";
import {secondsToTime} from '@/utils/date-util';
import { getTransportNameById } from '@/store/types';
import { template } from 'lodash';
import {getTranslatedParams} from "@/utils/notify-utils";
import {MsgTransports} from "@/store/types";

@Component({
  components: {
    NewPriceWings,
    TimeoutWings,
    SelectWings,
    ToggleWings,
    NumberWings
  },
})
export default class QuantityLimitsFilter extends BaseFilter<QuantityLimitFilter> {
  @PropSync('show') is_show!: boolean;

  @Action('getTransports') actionGetTransports: any;
  @Action('getTemplates') actionGetTemplates: any;
  @Action("getMessageTypes") actionGetMessageTypes: any;
  @Action('getQuantityLimits') actionGetQuantityLimits: any;

  @Getter('transports') transportsList: any;
  @Getter('smsTemplates') smsTemplatesList: any;
  @Getter('viberTemplates') viberTemplatesList: any;
  @Getter('pushTemplates') pushTemplatesList: any;
  @Getter('customTemplates') customTemplatesList: any;
  @Getter("messageTypes") messageTypesList?: MessageTypeItem[];

  defaultFilter(): QuantityLimitFilter {
    return new QuantityLimitFilterImpl();
  }

  templatesList: any = []
  templateName = ''

  async getTemplatesList(filter: any) {
    const transport = getTransportNameById.get(Number(this.filter.transports));
    const items = await this.actionGetTemplates({transport, filter});
    this.templatesList = (filter?.page_number > 1) ? this.templatesList.concat(items) : items
  }

  onTemplateSelect(val: number) {
    const template = this.templatesList.find((item: any) => item.id == val)
    this.templateName = template.name
  }

  async created() {
    try {
      this.actionGetTransports();
      this.actionGetMessageTypes();
      this.filtered();
    } catch (error) {
      notifyError(error);
    }
    const transport = getTransportNameById.get(Number(this.filter.transports));
    if (this.filter.transports && this.filter.templates) {
      this.templatesList = await this.actionGetTemplates({transport, filter: {id: this.filter.templates}});
      this.templateName = this.templatesList[0]?.name
    }
  }

  clear(): void {
    this.clearFilterValue('transports');
    this.clearFilterValue('templates');
    this.clearFilterValue('message_types');
    this.clearFilterValue('limit');
    this.clearFilterValue('timeout');
    this.filtered();
  }

  async onFilteredAction() {
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "The rule for limiting the quantity of messages",
        addititional_info: getTranslatedParams(this.filter)
      };
      await this.actionGetQuantityLimits(this.filter);
      await this.actionLog(this.logObject);
    }
    catch (err){
      await this.actionLog({...this.logObject, action_status: "failed"});
    }
  }

  get transportsFoQuantityLimitsList(): TransportItem {
    return this.transportsList.filter((t: TransportItem) => t.name !== MsgTransports.MAILNOTIFY);
  }

  // get templatesForQuantityLimitsList(): any {
  //   const transports = this.getTransportNameArray(this.filter.transports, false);
  //   return [...this.smsTemplatesList ?? [], ...this.viberTemplatesList ?? [], ...this.pushTemplatesList ?? [], ...this.customTemplatesList ?? []]
  //       .filter((t: any) => this.filter.transports && (transports?.includes(t.channel)))
  // }

  @Watch('filter.transports')
  onChannelChanged(val?: string, oldVal?: string): void {
    if (oldVal && val !== oldVal) {
      this.clearFilterValue('templates');
      this.clearFilterValue('message_types');
    }
  }

  clearFilterValue(field: string) {
    let defaultFilter: any = this.defaultFilter();
    this.$set(this.filter, field, defaultFilter[field]);
  }


  getTimeFromSeconds(seconds: number): string | null {
    return seconds ? secondsToTime(seconds) : null;
  }

  getTransportName(transport_id: number): string | undefined {
    return getTransportNameById.get(transport_id)
  }

  get getTemplateName(): string {
    return this.templateName
  }

  getMessageTypeNameArray(ids: number[] | undefined | null): any {
    if (ids && ids.length > 0) {
      let messageTypeNames: string[] = [];
      this.messageTypesList?.forEach((t: any) => {
        if (ids.includes(t.id)) {
          messageTypeNames.push(t.name);
        }
      })
      return this.getJoinedArray(messageTypeNames);
    } else {
      return undefined;
    }
  }

  getJoinedArray(item: string[] | undefined): string | undefined {
    if (item && item.length > 0) {
      return item.join(', ');
    } else {
      return undefined;
    }
  }
}
